import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Slide from "@material-ui/core/Slide";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
import { remove, popHead } from "./notificationSlice";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 9999,
    position: "fixed",
    top: 0,
    right: 0,
    margin: theme.spacing(1),
  },
  paper: {
    margin: theme.spacing(1),
  },
  close_action: {
    alignItems: "flex-start",
  },
}));

export default function Notification({ delay = 5000 }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const stack = useSelector((state) => state.notification.stack);
  const action_type = useSelector((state) => state.notification.action_type);

  const onRemove = (index) => () => {
    dispatch(remove(index));
  };

  useEffect(() => {
    if (stack.length && action_type === "push") {
      setTimeout(() => {
        dispatch(popHead());
      }, delay);
    }
  }, [stack, delay, dispatch, action_type]);

  return (
    <div className={classes.root}>
      {stack.map(({ severity, title, description }, index) => (
        <Slide
          direction="left"
          key={index}
          in={true}
          mountOnEnter
          unmountOnExit
        >
          <Paper elevation={4} className={classes.paper}>
            <Alert
              severity={severity}
              classes={{ action: classes.close_action }}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={onRemove(index)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              <AlertTitle>{title}</AlertTitle>
              {description}
            </Alert>
          </Paper>
        </Slide>
      ))}
    </div>
  );
}
